import { Box, InfoCardList, InfoCardProps } from '@forgeglobal/design-framework'
import { IssuerDealFragment } from 'graphql/bindings/AdminBindings'
import { formatAbbreviatedMoney } from 'util/NumberUtils'
import React from 'react'
import moment from 'moment'
import numeral from 'numeral'

export const TradeDetail: React.FC<{ deal: IssuerDealFragment }> = ({ deal }) => {
  const dataList = [deal].map<InfoCardProps>(deal => {
    const dateClosed = deal.dateClosed && moment(deal.dateClosed).format('M/D/YY')
    const { totalShares, netRevenue, averageTakeRate, numParticipants, grossPricePerShare } = deal
    const formattedRev = netRevenue ? formatAbbreviatedMoney(netRevenue) : 'No'

    return {
      leftTitle: dateClosed,
      leftSubtitle: `${numParticipants} participants`,
      rightTitle: formatAbbreviatedMoney(deal.totalVolume) || '–',
      rightSubtitle: `${numeral(grossPricePerShare).format('$0.00')} gross PPS`,
      notes: (
        <React.Fragment>
          <div>{numeral(totalShares).format('0,0')} shares</div>
          <div>{formattedRev} net revenue</div>
          <div>Average take rate {numeral(averageTakeRate).format('0.00%')}</div>
        </React.Fragment>
      ),
    }
  })

  return (
    <Box mt={1}>
      <InfoCardList items={dataList} />
    </Box>
  )
}
